export default {
domainInvalid: {
  siteUnavailableTitle: "Trang web không khả dụng",
  siteUnavailableDesc: "Trang web này hiện không khả dụng.",
  contactAdmin: "Vui lòng liên hệ quản trị viên.",
  serverErrorTitle: "Dịch vụ không khả dụng",
  serverErrorDesc: "Không thể kết nối đến máy chủ, vui lòng thử lại sau.",
  serverErrorTip: "Hệ thống sẽ tự động kết nối lại khi máy chủ hoạt động trở lại.",
  notAuthorizedTitle: "Tên miền chưa được cấp quyền",
  notAuthorizedDesc: "Tên miền hiện tại chưa được cấp quyền truy cập dịch vụ này.",
  checking: "Đang kiểm tra...",
  retry: "Thử lại",
  reload: "Tải lại",
  reloading: "Đang tải lại...",
  checkingDomain: "Đang kiểm tra tên miền...",
  authorizedRedirecting: "Tên miền đã được cấp quyền, đang chuyển hướng...",
  stillNotAuthorized: "Tên miền vẫn chưa được cấp quyền",
  reconnecting: "Đang kết nối lại..."
}
};
